module.exports = __webpack_public_path__ + "img/cp73-r4.067186d6.jpg";